// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"258":"2498d591","397":"7d27ad47"}[chunkId] + ".chunk.css";
};